import axios from "axios";
import React, { useEffect, useState } from "react";
import requests from "../../utils/Requests";
import { Field, reduxForm } from "redux-form";
import RenderField from "../../form-components/RenderField";
import { Card, CardHeader, Button, Row, Col } from "reactstrap";
import { useParams } from "react-router";
const MealsBookingForm = (props) => {
  const { handleSubmit } = props;
  const { id } = useParams();
  useEffect(() => {
    getMealsTicketList();
  }, []);

  const getMealsTicketList = async () => {
    try {
      const res = await axios.post(requests.getMealTicketList, {
        mealOptionsId: id,
      });

      console.log(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const submitToApi = (values) => {
    const postToApi = {
      ...values,
      mealOptionsId: 1,
      bookNumber: "osncis",
      bookPaymentAmount: 3543,
      bookTotal: 656,
      bookB2bId: 0,
      bookB2cId: 0,
      bookB2bUserId: 0,
      price: 2323,
      platformId: 1,
      b2bBooking: true,
      b2cBooking: false,
    };

    console.log(postToApi);
  };
  return (
    <div
      style={{
        marginTop: "24px",
      }}
    >
      <Card>
        <CardHeader>
          <h3 className="single-page-small-title">Book Now </h3>
        </CardHeader>
        <div
          style={{
            padding: "12px",
          }}
        >
          <Field
            name="bookCustomerName"
            type="text"
            label="Lead Passenger Name"
            component={RenderField.RenderTextField}
          />
          <Field
            name="bookMobileNumber"
            type="text"
            label="Mobile Number"
            component={RenderField.RenderTextField}
          />
          <Field
            name="bookCustomerEmail"
            type="text"
            label="Email"
            component={RenderField.RenderTextField}
          />
          <Field
            name="bookTravellDate"
            type="date"
            label="Travel Date"
            component={RenderField.RenderDateField}
          />
          <Field
            name="nofMeals"
            type="number"
            label="Number Of Meals"
            component={RenderField.RenderTextField}
          />

          <Row style={{ marginTop: "12px" }}>
            <Col>
              <label>
                <Field
                  name="bookPaymentMode"
                  component="input"
                  type="radio"
                  value="1"
                />{" "}
                Online
              </label>
            </Col>
            <Col>
              <label>
                <Field
                  name="bookPaymentMode"
                  component="input"
                  type="radio"
                  value="2"
                />{" "}
                Credit
              </label>
            </Col>
          </Row>

          <div
            className="d-flex justify-content-end "
            style={{
              marginTop: "12px",
            }}
          >
            <Button
              color="primary"
              className="btn btn-yellow"
              onClick={handleSubmit((values) =>
                submitToApi({
                  ...values,
                  pill: 1,
                })
              )}
            >
              Book Now
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default reduxForm({
  form: "MealsBookingForm",
  initialValues: {
    bookPaymentMode: "2", // 👈 Set default value here
  },
})(MealsBookingForm);
